import styled from "@emotion/styled"
import { css } from "@emotion/react"
import {
  logoRed,
  darkGrey,
  offWhite,
  logoOrange,
  Fira,
} from "../../globalCss"
import { Link } from "gatsby"

export const NavContainer = styled.header`
  z-index: 99;
  position: fixed;
  width: 100%;
  top: 0;
  height: 8rem;
  display: flex;
  justify-content: center;
  background-color: ${offWhite};
  .active {
    color: ${logoRed};
    font-weight: 600;
  }
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
`
export const NavBar = styled.div`
  position: relative;
  height: 8rem;
  width: 100%;
  margin: 0 auto;
  display: flex;
  background-color: ${offWhite};
  justify-content: flex-start;
  align-items: stretch;
  line-height: 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
`

export const NavbarItem = styled.div`
  position: relative;
  display: flex;
  justify-content: center;

  &:first-of-type {
    margin-left: auto;
  }

  @media only screen and (max-width: 800px) {
    display: none;
  }
`

export const NavLink = styled(Link)`
  ${Fira}
  font-weight: 500;
  height: 8rem;
  font-size: 1.8rem;
  padding: 0 2rem;
  color: ${darkGrey};
  text-decoration: none;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  letter-spacing: 0.02rem;
  transition: all 0.3s ease-in-out;

  &:hover {
    color: ${logoOrange};
    background-color: rgba(0,0,0,0.02);
  }

  @media only screen and (max-width: 800px) {
    display: none;
  }
`

export const LogoContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`

export const Logo = styled.img`
  height: 6rem;
`

export const DropdownLink = css`
  ${Fira}
  font-weight: 500;
  height: 6rem;
  font-size: 1.6rem;
  color: ${darkGrey};
  text-decoration: none;
  padding: 0rem 2rem;
  background-color: ${offWhite};
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  transition: all ease-in-out 0.3s;
  white-space: nowrap;

  &:hover {
    color: ${logoOrange};
    background-color: rgba(0, 0, 0, 0.02);
  }

  @media only screen and (max-width: 800px) {
    display: none;
  }
`
export const DropdownContent = styled.div`
  z-index: 6;
  position: absolute;
  top: 8rem;
  width: max-content;
  left: 50%;
  transform: translateX(-50%);
  min-width: 100%;
  background-color: transparent;
  transition: all 0.3s ease-in-out;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);

  @media only screen and (max-width: 800px) {
    display: none;
  }
`

export const Dropdown = css`
  position: relative;
  transition: all 0.3s ease-in-out;

  &:focus {
    outline: none;
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.02);
  }

  &:hover .dropdown-content {
    opacity: 1;
    visibility: visible;
    background-color: ${offWhite};
    pointer-events: auto;
  }

  @media (any-pointer: none) {
    &:focus-within .dropdown-content {
      opacity: 1;
      visibility: visible;
      background-color: ${offWhite};
    }
  }

  @media only screen and (max-width: 800px) {
    display: none;
  }
`

export const DropdownHeader = styled.div`
  ${Fira}
  font-weight: 500;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.8rem;
  color: ${darkGrey};
  text-decoration: none;
  padding: 0 2rem;
  height: 8rem;
  letter-spacing: 0.02rem;
  transition: all 0.3s ease-in-out;

  &:hover {
    color: ${logoOrange};
    background-color: rgba(0, 0, 0, 0.02);
  }
`

export const MenuToggle = styled.button`
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  margin-left: auto;
  padding: 0;
  align-items: center;
  color: ${darkGrey};
  transition: all 0.3s ease-in-out;

  &:hover,
  &:focus {
    color: ${logoOrange};
    outline: none;
  }

  span {
    ${Fira}
    font-size: 1.6rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.1rem;
    margin-right: 1.2rem;
  }

  @media only screen and (max-width: 800px) {
    display: flex;
  }
`

export const BurgerIcon = styled.div`
  width: 2.4rem;
  height: 2px;
  background-color: currentColor;
  position: relative;
  transition: all 0.3s ease-in-out;

  &::before,
  &::after {
    content: "";
    position: absolute;
    right: 0;
    height: 2px;
    background-color: currentColor;
    transition: all 0.3s ease-in-out;
  }

  &::before {
    top: -0.8rem;
    width: 100%;
  }

  &::after {
    bottom: -0.8rem;
    width: 60%;
  }

  ${props =>
    props.isOpen &&
    `
    background-color: transparent;
    &::before {
      transform: translateY(0.8rem) rotate(45deg);
      width: 100%;
    }
    &::after {
      transform: translateY(-0.8rem) rotate(-45deg);
      width: 100%;
    }
  `}
`

export const Menu = styled.div`
  display: none;
  @media only screen and (max-width: 800px) {
    display: initial;
    position: fixed;
    height: calc(100vh - 8rem);
    top: 8rem;
    width: 100vw;
    background-color: ${offWhite};
    z-index: 999;
  }
`

export const MenuList = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
`

export const MenuLink = styled(Link)`
  ${Fira}
  font-weight: 500;
  height: 6rem;
  font-size: 2rem;
  width: 100%;
  color: ${darkGrey};
  text-decoration: none;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  &:active {
    color: ${logoRed};
  }
`
